import { render, staticRenderFns } from "./LessonsListV2.vue?vue&type=template&id=0ccf0ff0&scoped=true&lang=pug&"
import script from "./LessonsListV2.vue?vue&type=script&lang=js&"
export * from "./LessonsListV2.vue?vue&type=script&lang=js&"
import style0 from "./LessonsListV2.vue?vue&type=style&index=0&id=0ccf0ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf0ff0",
  null
  
)

export default component.exports